import { FaqTopics } from './faq-topics';
import { Faqs } from "./faqs";

new FaqTopics();
new Faqs();